// extracted by mini-css-extract-plugin
export default {"feedback-data":"feedback-data","disable-btn":"disable-btn"};